<div class="flex flex-col w-full gap-2 px-2">
  <div class="flex items-center justify-center">
    <span class="text-primarys shadow-lg p-2">
      Login Now </span>
  </div>
  <form [formGroup]="authForm" class="login-container gap-2 flex flex-col" (ngSubmit)="signIn()">
    

<div>
      <span>Email</span>
      <!-- <app-text-input-tool placeholder="9569639502"></app-text-input-tool> -->
      <input id="custom-input" placeholder="Enter your email" formControlName="email" name="email" type="email"
        class="w-full border p-1 rounded-md outline-none" />

      <div *ngIf="authForm.get('email')?.errors?.['required'] && authForm.get('email')?.touched" class="text-red-500">
        Email is required
      </div>
    </div>
    <div class="relative">
      <span>Password</span>
      <div class="relative password-input-wrapper">
        <input placeholder="***********" [type]="showPassword ? 'password' : 'text'" formControlName="password"
          name="password" class="w-full border p-1 rounded-md outline-none pr-10 password-toggle-input" (keydown.enter)="signIn()" />

        <button type="button" tabindex="-1" *ngIf="showPassword" (click)="showPassword = false"
          class="password-toggle-btn absolute right-0 top-0 bottom-0 w-10 flex items-center justify-center cursor-pointer border-0 bg-transparent"
          aria-label="Show password">
          <img src="assets/image/eye.svg" alt="" class="w-5 h-5 opacity-70" />
        </button>
        <button type="button" tabindex="-1" *ngIf="!showPassword" (click)="showPassword = true"
          class="password-toggle-btn absolute right-0 top-0 bottom-0 w-10 flex items-center justify-center cursor-pointer border-0 bg-transparent"
          aria-label="Hide password">
          <img src="assets/image/closeeye.svg" alt="" class="w-5 h-5 opacity-70" />
        </button>
      </div>
      <div *ngIf="authForm.get('password')?.errors?.['required'] && authForm.get('password')?.touched"
        class="text-red-500">
        Password is required
      </div>
      <span class="text-primary text-sm cursor-pointer" routerLink="/forgot-password">
        Forgot Password?
      </span>
      <!-- <span class="text-primary text-sm" routerLink="/reset-password">
        Reset Password?
      </span> -->

      <!--  -->
      <div class="text-red-500"
        *ngIf="authForm.invalid && !authForm.get('password')?.errors?.['required'] && !authForm.get('email')?.errors?.['required']">
        Incorrect username or password</div>
    </div>
    <div *ngIf="false" class="relative">
      <input type="checkbox" formControlName="acceptTerms" id="acceptTerms" style="margin-right: 5px;"
        class=" border p-1 rounded-md outline-none form-check-input" />
      <label for="acceptTerms" class="form-check-label"> I accept the <b>Terms &amp; Conditions</b> and <b>Privacy
          Policy </b></label>
      <div *ngIf="authForm.get('acceptTerms')?.errors?.['required'] && authForm.get('acceptTerms')?.touched"
        class="text-red-500">Accept Ts & Cs is required</div>
    </div>
    <div class="items-center justify-center flex">
      <!-- <app-primary-button routerLink="/user-verification"> -->
      <app-primary-button>
        <div class="gap-2 flex items-center">
          <img src="assets/image/Shape.svg" alt="" class="h-4" />
          Secure Login
        </div>
      </app-primary-button>
    </div>
    
  <!-- Login Link Section -->
  <div class="login-section pt-2">
    <!-- <p class="login-text">Don't have an account?</p> -->
    <button mat-stroked-button color="primary" class="login-btn" (click)="goToSignup()">
      <mat-icon>signup</mat-icon>
      Go to Signup
    </button>
  </div>
    <!-- <div class="text-center d-none">
      <span class="text-primary text-sm" routerLink="/onboarding" style="cursor: pointer;">
        Signup Now
      </span>
    </div> -->
  </form>
  <!-- <div *ngIf="user; else loginBlock">
    <p>Welcome, {{ user.displayName }}!</p>
    <button (click)="logout()">Logout</button>
  </div> -->

  <!-- <button (click)="loginWithGoogle()">Login with Google</button>
    <button (click)="loginWithFacebook()">Login with Facebook</button> -->

  <div *ngIf="false" class="login-buttons">
    <button (click)="loginWithGoogle()">
      <img src="../../../assets/image/envelope.png" alt="Google" />
      Login with Google
    </button>

    <button (click)="loginWithFacebook()">
      <img src="../../../assets/image/facebook.png" alt="Facebook" />
      Login with Facebook
    </button>
  </div>

</div>


<style>
  /* .login-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin: 20px 0;
}

.login-buttons button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 10px 16px;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: #f1f1f1;
  transition: background-color 0.3s ease;
}

.login-buttons button:hover {
  background-color: #e0e0e0;
}

.login-buttons img {
  width: 20px;
  height: 20px;
} */


  /* ===== Primary Button Styling ===== */
  app-primary-button {
    /* background-color: #3a5aef !important; */
    font-size: 18px;
    font-weight: 500;
    color: white !important;
    cursor: pointer;
    border-radius: 8px;
    
    transition: all 0.3s ease;
    display: inline-block;
  }

  app-primary-button:hover {
    
    transform: translateY(-2px);
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
  }

input[type="email"],
input[type="password"],
input[type="text"] {
    background-color: #ffffff;
    border: 2px solid #e5e7eb; 
    padding: 12px 14px;
    border-radius: 8px;
    font-size: 16px;
    outline: none;
    width: 100%;
    color: #111827;
    transition: all 0.3s ease;
    box-sizing: border-box;
}

/* Lock height for password field to prevent layout shift on visibility toggle */
.password-input-wrapper {
  min-height: 48px;
}

.password-toggle-input {
  height: 48px !important;
  min-height: 48px !important;
  font-family: inherit;
}


input[type="email"]:hover,
input[type="password"]:hover,
input[type="text"]:hover {
    border-color: #cbd5e1; 
}


input[type="email"]:focus,
input[type="password"]:focus,
input[type="text"]:focus {
    border-color: #3a5aef; 
    box-shadow: 0px 0px 6px rgba(58, 90, 239, 0.4); 
    background-color: #ffffff; 
}


input::placeholder {
    color: #9ca3af; 
    font-size: 14px;
}




  
  form span {
    display: block;
    margin-bottom: 6px;
    font-weight: 500;
    
    color: #3a5aef !important;

  }




  
  .text-primary {
    color: #3a5aef !important;
    transition: color 0.3s ease;
    margin-top: 8px;

  }

  .text-primary:hover {
    color: #0d2aab !important;
    text-decoration: underline;
  }

 
  .relative img {
    cursor: pointer;
    transition: transform 0.2s ease;
  }

  .relative img:hover {
    transform: scale(1.1);
  }

  /* Password toggle: larger hit area, no layout shift on hover */
  .password-toggle-btn {
    transition: opacity 0.2s ease;
    outline: none;
  }

  .password-toggle-btn:hover {
    opacity: 1;
  }

  .password-toggle-btn:hover img {
    opacity: 1;
  }

  .password-toggle-btn img {
    transition: opacity 0.2s ease;
    pointer-events: none;
  }

  .password-toggle-btn:hover img {
    transform: none;
  }

 
  .text-center .text-primary {
    font-size: 16px;
    font-weight: 500;
  }

  .text-center .text-primary:hover {
    font-size: 16px;
    font-weight: 500;
    text-decoration: underline;

  }

  .text-primarys {
    color: #3a5aef !important;
    transition: color 0.3s ease;
    border-bottom: 4px solid #3a5aef;
    font-size: 22px;
    font-weight: 600;
    border-radius: 20px;
    text-align: center;
  }





  .login-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    margin: 0rem 0rem;
    /* padding-top: 1rem; */
    border-top: 1px solid #e5e7eb;
  }

  .login-text {
    color: #6b7280;
    font-size: 1rem;
    margin: 0;
  }

  .login-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.5rem;
    font-weight: 500;
    border-radius: 0.5rem;
    transition: all 0.2s ease;
  }

  .login-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

</style>